import { render, staticRenderFns } from "./medals.vue?vue&type=template&id=1a3c0c95&scoped=true&"
import script from "./medals.vue?vue&type=script&lang=js&"
export * from "./medals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c0c95",
  null
  
)

export default component.exports